import * as React from "react";

import "./sub-total-summary.scss";

import {formatMoney1} from "@Common/ui-components/language/format-money";
import {chain}        from "@Common/utils/fs";

import {summaryLines} from "../common/summary-lines-expo";

export const subTotalSummary = ({item, mailingLists, canadaMailing}) => [
    {
        load: ({paperType, paperPrice, addressLists1, addressLists2, mailingClass2, method, totalQuantity, sampleMailingCard}, next) => next({
            summaryLines: [
                {
                    order: 1,
                    className: "sub-total-summary-9eb",
                    details: [
                        {
                            label: (
                                <span className="orderName-5tw">
                                    {item.itemName || item.metaData?.productName || "Brochure"}
                                </span>
                            ),
                            text: item.itemName || item.metaData?.productName || "Brochure",
                        },
                        chain(
                            `${paperType.name} - (${formatMoney1(paperPrice?.price ?? 0)} each)`,
                            (_) => ({
                                text: _,
                                label: _,
                            })
                        ),
                        chain(
                            method === "mailing" && (
                                mailingClass2?.mailingClassId === "1"? (
                                    canadaMailing ? "Canadian Lettermail" : "First Class Mail Service"
                                ): ( mailingClass2?.mailingClassId === "5"? "Neighborhood Direct Mail" : (
                                    canadaMailing ? "Canadian Admail" : "Standard Mail Service"
                                ))
                            ),
                            (_) => ({
                                text: _,
                                label: _,
                            })
                        ),


                        (() => {
                            const listNames = addressLists2 && mailingLists
                                ?.filter((ml) => addressLists1.state.value.findIndex((id) => id == ml.id) > -1)
                                .map((ml) => ml.mailingListName)
                                .filter(v=>v)
                                .join(", ")
                            ;
                            return (
                                listNames && {
                                    label: <span className="addressLists-68d">Mailed to address lists: {listNames}</span>,
                                    text: `Mailed to address lists: ${listNames}`,
                                });
                        })(),
                        sampleMailingCard?.includeSampleCardCost && {
                            label: (
                                <span className="addressLists-68d">
                                    +1 sample card
                                </span>
                            ),
                            text: "+1 sample card",
                        }
                    ].filter(v => v),

                    ...paperPrice?.isFlatRate ? {
                        amount: paperPrice?.price ?? 0,
                    } : {
                        unitPrice: paperPrice?.price ?? 0,
                        qty: totalQuantity
                    },
                },
            ],
        }),
        requires: ["paperType", "paperPrice", "addressLists1", "addressLists2", "mailingClass2", "method", "totalQuantity", "sampleMailingCard"],
        expo: [summaryLines],
    },
];

